import 'slick-carousel';

class Carousel {

    constructor(el, options) {
        this.el = el;

        // CSS variables
        this.globalMaxWidth = '1160px';
        this.remBase = 17;
        this.gutterSmall = `${27 / this.remBase}rem`;
        this.gutterLarge = `${36 / this.remBase}rem`;

        // We calculate the center padding by extracting the global max width and twice the gutters from the 100% width of the carousel
        // and divice it by 2 because the center padding appears left and right of the active slide.
        this.centerPaddingLarge = `calc((100% - (${this.globalMaxWidth} - ${this.gutterLarge} - ${this.gutterLarge})) / 2)`;

        this.init();
    }

    init() {
        $(this.el).slick({
            centerMode: true,
            mobileFirst: true,
			centerPadding: this.gutterSmall,
			dots: true,
            responsive : [{
                breakpoint: this.globalMaxWidth.replace('px', ''), // without the `px`
                settings: {
					centerPadding: this.centerPaddingLarge,
					dots: false
                }
            }]
        });
    }

}

export { Carousel as Carousel };
